import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { PastStay } from 'src/features/stay/types';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/visitors/past-stay/:stayId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    stayId: string;
}
const queryFn = ({ stayId, parkingId, ...params }: DTO): Promise<PastStay> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, stayId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as PAST_STAY_RESOURCE, useQueryHook as useGetPastStay };
